var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 33",
    style: {
      enableBackground: "new 0 0 33 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1E2224;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.7,31.5C7.1,31.5,0,24.4,0,15.7S7.1,0,15.7,0s15.7,7.1,15.7,15.7S24.4,31.5,15.7,31.5z M15.7,2.5 C8.5,2.5,2.5,8.5,2.5,15.7s5.9,13.2,13.2,13.2S28.9,23,28.9,15.7S23,2.5,15.7,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.7,33c-0.3,0-0.6-0.1-0.9-0.4l-5.3-5.3c-0.5-0.5-0.5-1.3,0-1.8s1.3-0.5,1.8,0l5.3,5.3 c0.5,0.5,0.5,1.3,0,1.8C32.4,32.9,32.1,33,31.7,33L31.7,33z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNavbar);
export default __webpack_public_path__ + "static/media/search-navbar.fa1c342d2be65eb9d9bbd50a6fcfbfc5.svg";
export { ForwardRef as ReactComponent };